import React from 'react';
import { Box } from '@mui/material';
import SearchBar from '../commonSearch/SearchBar';
import CommonFilter from '../commonFilter/CommonFilter';
import DateTab from '../../pages/date/Date';
import { useLocation } from 'react-router-dom';

const CommonSDF = (props) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const section = pathSegments[1];
  const tabValue = pathSegments[3]; // Get the tab value from URL
  // Check if we're in a vendor city path (vendor/:city/...)
  const isVendorCityPath = section === "vendor" && pathSegments.length > 2;
  const isUserTab = tabValue === '4';

  return (
    <Box
    sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'flex-end', sm: 'flex-end', md: 'flex-end' },
    flexWrap: 'nowrap',
    width: '100%',
    gap: { xs: 1, sm: 2 },
  }}
    >
      {/* Search Bar Logic - Show for all vendor city paths including user tab */}
      {(["rideTrack", "customer", "compliance", "coupon", "vendor", "complaints", "invoice"].includes(section) || isVendorCityPath) && (
        <Box sx={{ flexShrink: 1, minWidth: { xs: '130px', sm: '180px' } }}>
          <SearchBar
            {...props}
            placeholder={
              section === "complaints" 
              ? "Search by Ticket Id" 
              : section === "rideTrack" || section === "invoice"
              ? "Search by ID"
              : "Search"}
            fullWidth
          />
        </Box>
      )}

      {/* Date Tab Logic */}
      {["rideTrack", "dashboard", "feedback", "booking"].includes(section) && (
        <Box sx={{ width: '280px' }}>
          <DateTab {...props} fullWidth />
        </Box>
      )}

      {/* Filter Logic - Show for vendor city paths EXCEPT user tab */}
      {(["rideTrack", "customer", "compliance", "feedback", "complaints", "report-generate"].includes(section) || (isVendorCityPath && !isUserTab)) && (
        <Box sx={{ flexShrink: 0 }}>
          <CommonFilter {...props} />
        </Box>
      )}
    </Box>
  );
};

export default CommonSDF;